import { render, staticRenderFns } from "./PurchasesTreeTableHeader.vue?vue&type=template&id=4f8b1ca5&scoped=true"
import script from "./PurchasesTreeTableHeader.vue?vue&type=script&lang=js"
export * from "./PurchasesTreeTableHeader.vue?vue&type=script&lang=js"
import style0 from "./PurchasesTreeTableHeader.vue?vue&type=style&index=0&id=4f8b1ca5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8b1ca5",
  null
  
)

export default component.exports